module.exports = __webpack_public_path__ + "img/diagnostics.f4107f86.svg";